import React from 'react';

const FooterSection: React.FC<{
	className?: string;
	children: JSX.Element | string;
}> = ({ className, children }) => {
	return (
		<div className={className || 'bg-neutral'}>
			<div className="px-6">
				<div className="max-w-6xl mx-auto">{children}</div>
			</div>
		</div>
	);
};

export default FooterSection;
